import React from 'react';

import '@css/tailwind.css';
import '@css/main.css';

import { Background } from './background';
import { PageLoader } from '@components/pageLoader';
import { CustomCursor } from '@components/ui/customCursor';
import Footer from './footer/footer';
import Header from './nav/header';

import { DonateModal } from './donations/donateModal';

const Layout = ({ children, config, ticketingPage }) => {
  return (
    <>
      <Header {...config} ticketingPage={ticketingPage} />
      <main className='w-full absolute top-0 left-0'>
        <Background ticketingPage={ticketingPage}>
          {children}
          <Footer />
        </Background>
      </main>
      {/* reinstate when season reopens */}
      {/* <SubscriptionForm /> */}
      <DonateModal />
      <PageLoader />
      <CustomCursor />
    </>
  );
};

export default Layout;
